import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Search, Loader2 } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { AiSummary, StudyList } from "@/components/evidence/shared";

export const PubMedSearch = ({ user, t, lang }) => {
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const search = async (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    setLoading(true); setData(null);
    try {
      const { data } = await api.get(`/pubmed/search`, { params: { q, language: lang } });
      setData(data);
    } catch (e2) { toast.error(apiError(e2)); } finally { setLoading(false); }
  };

  if (!user) return (
    <div className="rounded-xl border border-gray-200 bg-white p-6 text-center" data-testid="pubmed-guest-notice">
      <p className="mb-3 text-sm text-gray-600">{t("ev.searchGuest")}</p>
      <Link to="/register" className="inline-block rounded-full bg-emerald-500 px-5 py-2.5 text-sm font-bold text-white hover:bg-emerald-600">{t("nav.register")}</Link>
    </div>
  );

  return (
    <div>
      <p className="mb-3 text-sm text-gray-600">{t("pubmed.sub")}</p>
      <form onSubmit={search} className="mb-6 flex gap-2">
        <div className="relative flex-1">
          <Search size={18} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
          <input data-testid="pubmed-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("pubmed.search")}
            className="w-full rounded-full border border-gray-200 py-3 pl-11 pr-4 text-sm outline-none focus:border-emerald-400 focus:ring-2 focus:ring-emerald-100" />
        </div>
        <button data-testid="pubmed-search-button" disabled={loading}
          className="flex items-center gap-2 rounded-full bg-emerald-500 px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-emerald-600 disabled:opacity-60">
          {loading ? <Loader2 size={16} className="animate-spin" /> : <Search size={16} />} {t("pubmed.go")}
        </button>
      </form>
      {loading && <p className="mb-6 flex items-center gap-2 text-sm text-gray-500"><Loader2 size={15} className="animate-spin" /> {t("pubmed.searching")}</p>}
      {data && (
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="space-y-4">
          <AiSummary text={data.ai_summary} stage={data.evidence_stage} t={t} />
          <h3 className="text-sm font-bold uppercase tracking-wider text-gray-400">{t("pubmed.studies")}</h3>
          <StudyList studies={data.studies || []} />
        </motion.div>
      )}
    </div>
  );
};
